/** @jsxImportSource @emotion/react */
import { useEffect, useState, Fragment, Children } from 'react';

import Toast, { PropsType as ToastPropsType } from './Toast';

export interface PropsType {
  option: ToastPropsType;
}

function ToastContainer({ option }: PropsType) {
  const [toasts, setToasts] = useState<ToastPropsType[]>([]);

  const updateToastItems = () => {
    if (option) {
      setToasts([...toasts, option]);
    }
  };

  useEffect(updateToastItems, [option]);

  return (
    <Fragment>
      {Children.toArray(toasts.map(({ ...props }) => <Toast insertToBody={false} {...props} />))}
    </Fragment>
  );
}

export default ToastContainer;
